import script from "./BaseGallery.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseGallery.vue?vue&type=script&setup=true&lang=js"

import "./BaseGallery.vue?vue&type=style&index=0&id=a25a0832&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a25a0832"]])

export default __exports__